import { render, staticRenderFns } from "./asterisk.vue?vue&type=template&id=45471052&scoped=true&"
var script = {}
import style0 from "./asterisk.vue?vue&type=style&index=0&id=45471052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45471052",
  null
  
)

export default component.exports